import { render, staticRenderFns } from "./mGobalFooter.vue?vue&type=template&id=28485b0a&scoped=true&"
import script from "./mGobalFooter.vue?vue&type=script&lang=js&"
export * from "./mGobalFooter.vue?vue&type=script&lang=js&"
import style0 from "./mGobalFooter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mGobalFooter.vue?vue&type=style&index=1&id=28485b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28485b0a",
  null
  
)

export default component.exports